import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {UtilService} from './util.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {LoaderService} from './loader.service';

@Injectable()
export class HcaBrandService {

  constructor(
    private http: HttpService,
    private utilService: UtilService,
    private loaderService: LoaderService
  ) {
  }

  getBrandDetailsByBrandId(id) {
    return this.http.get(`/brand/getBrandById/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getLanguageCodes() {
    return this.http.get(`/brand/getLanguageCodes/`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getCountries() {
    return this.http.get(`/brand/getCountries`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  updateBrandDetails(brand) {
    this.loaderService.show();
    const url = `brand/updateBrandDetails`;
    const token = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).token : null;
    return Observable.create((observer) => {
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this.loaderService.hide();
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            this.loaderService.hide();
            observer.error(JSON.parse(xhr.response));
          }
        }
        return () => {
          this.loaderService.hide();
          xhr.abort();
        };
      };
      xhr.open('POST', `${environment.BASE_API}${environment.ROLE}/${url}`, true);
      xhr.setRequestHeader('X-Auth-Token', token);
      xhr.send(brand);
    });
  }

  createBrand(brand) {
    return this.http.post(`/brand/createBrand`, brand)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-brand.service.ts